import gsap from 'gsap';

export default () => {
	const cards = document.querySelectorAll('.card');
	const CLASS_EXPANDED = 'is-expanded';
	const CLASS_LIST = 'card__sizes-list';
	const CLASS_BTN = 'js-sizes-expand';

	cards.forEach(function(card) {
		initCard(card);
	});

	function initCard(card) {
		const buttons = card.querySelectorAll(`.${CLASS_BTN}`);
		const list = card.querySelectorAll(`.${CLASS_LIST}`);

		buttons.forEach(function(btn) {
			btn.addEventListener('click', (e) => {
				let isActive = card.classList.toggle(CLASS_EXPANDED);

				gsap.to(list,
					{
						height: isActive ? 'auto' : 0,
						duration: 0.2
					}
				);
			});
		});


		card.addEventListener('mouseleave', (e) => {
			resetCard(card);
		});
	}

	function resetCard(card) {
		card.classList.remove(CLASS_EXPANDED);
		card.classList.remove('is-selecting-size');

		const options = card.querySelectorAll('.card__sizes-btn');
		options.forEach(function(option) {
			option.removeAttribute('data-no-swup');
		});

		gsap.to(card.querySelectorAll(`.${CLASS_LIST}`),
			{
				height: 0,
				duration: 0.2
			}
		);
	}
	
	window.initCard = initCard;
	window.resetCard = resetCard;
}